import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import clsx from 'clsx';

const GoogleMap = ({ children, place, ...props }) => {
	const { show } = place || {};
	return (
		<section
			className={clsx('location-search__map', show && show === true && 'is-active')}
		>
			<GoogleMapReact
				bootstrapURLKeys={{
					key: process.env.GATSBY_MAP_KEY,
				}}
				{...props}
			>
				{children}
			</GoogleMapReact>
		</section>
	);
};

GoogleMap.propTypes = {
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
	place: PropTypes.shape({
		name: PropTypes.string,
		street: PropTypes.string,
		city: PropTypes.string,
		postal: PropTypes.string,
		state: PropTypes.string,
		country: PropTypes.string,
		description: PropTypes.string,
		url: PropTypes.string,
		phone1: PropTypes.string,
		time: PropTypes.string,
		show: PropTypes.bool,
	}),
};

GoogleMap.defaultProps = {
	children: null,
};

export default GoogleMap;
